const { requestManager } = require('../../requestManager');

const { API_PATH } = require('../../config/config');

class ServNameMastaApi {
  /**
   * サービス名取得
   * @param {string} lgCd 市町村コード
   * @return {Promise<String>} サービス名
   */
  getServName = async (lgCd, servCd) => {
    const params = { lgCd, servCd };

    const result = await requestManager.post(`${API_PATH}/masta/srvname/r`, params);
    return result.data;
  };
}

export default new ServNameMastaApi();
